import React, { useState, useEffect } from "react";
import Modal from "./Modal";
import { Close } from "../icons";
import Input from "../common/Input";

export default function StockAdjustmentModal({
  open,
  onClose,
  onSubmit,
  productName = "",
  currentStock = 0,
  isLoading = false,
}) {
  const [mode, setMode] = useState("add"); // 'add' or 'deduct'
  const [quantity, setQuantity] = useState("");
  useEffect(() => {
    if (open) {
      setQuantity("");
      setMode("add");
    }
  }, [open]);

  const quantityNum = Number(quantity) || 0;
  const newBalance =
    mode === "add"
      ? Number(currentStock) + quantityNum
      : Math.max(0, Number(currentStock) - quantityNum);

  function handleSubmit() {
    onSubmit?.({
      mode,
      quantity: quantityNum,
      amount: quantityNum,
      newBalance,
    });
  }

  const isAdd = mode === "add";
  const buttonLabel = isAdd ? "Confirm Increase" : "Confirm Decrease";
  const buttonColor = isAdd ? "bg-[#6D4E8A]" : "bg-[#DC2626]";
  const hoverColor = isAdd ? "hover:bg-[#5a3f75]" : "hover:bg-[#c41f1f]";

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="max-w-[416px] pt-7 pb-11 px-0"
      centered={false}
    >
      <div className="w-full">
        <div className="flex items-center justify-between mb-4 pl-7 pr-10">
          <div>
            <p className="text-xl font-bold leading-6 text-black">
              Stock Adjustment
            </p>
            <p className="text-sm text-[#000] leading-4">{productName}</p>
          </div>
          <button onClick={onClose} aria-label="close">
            <Close />
          </button>
        </div>

        <div className="border-t border-[#E5E5E5] pt-4 pl-7 pr-10">
          {/* Add/Deduct Toggle */}
          <div className="grid grid-cols-2 gap-2 mb-7 bg-[#F0F0F0] rounded-[5px] p-2.5">
            <button
              onClick={() => setMode("add")}
              className={`  text-xs leading-6 rounded-[5px] transition ${
                isAdd
                  ? "bg-[#3CA966] text-white font-bold"
                  : "bg-[#fff] text-black hover:bg-[#D9D9D9]"
              }`}
            >
              Add
            </button>
            <button
              onClick={() => setMode("deduct")}
              className={`  text-xs rounded-[5px] transition ${
                !isAdd
                  ? "bg-[#FF3B3B] text-white font-bold"
                  : "bg-[#E5E5E5] text-black hover:bg-[#D9D9D9]"
              }`}
            >
              Deduct
            </button>
          </div>

          {/* Quantity Input */}
          <Input
            label="Quantity Amount"
            type="number"
            min="0"
            value={quantity}
            onChange={(e) => {
              let val = e.target.value;
              if (val !== "" && Number(val) < 0) {
                val = "0";
              }
              setQuantity(val);
            }}
            placeholder="Enter quantity"
          />

          {/* New Expected Balance */}
          <div className="mt-7">
            <label className="text-sm leading-6 text-black block mb-2">
              New Expected Balance
            </label>
            <div className="w-full bg-[#F2F2F2] px-4 py-3 rounded-[10px] flex items-center justify-between">
              <p className="text-sm text-[#A2A1A8]">Total Balance</p>
              <p className="text-sm leading-6 font-bold text-[#3CA966]">{newBalance}</p>
            </div>
          </div>

          {/* Submit Button */}
          <button
            onClick={handleSubmit}
            disabled={isLoading}
            className={`w-full mt-7 ${buttonColor} ${hoverColor} text-white py-2.5  text-sm leading-6 rounded-[5px] transition disabled:opacity-50`}
          >
            {isLoading ? "Adjusting..." : buttonLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
